const $kmobilebridge={
    loginbypassword:function(servername, enable, username, password, logintype){
        var payload = {"func": "loginbypassword", "servername": servername, "ssl": enable, "username": username, "password": password, "logintype": logintype};
        var res = prompt(JSON.stringify(payload));
        return res;
    },
    kabalamobile_invoke:function(op,param){
        var payload = {"func": "kabalamobile_invoke", "op": op, "param": param};
        var res = prompt(JSON.stringify(payload));
        console.log('bridge调用===>')
        console.log(res)
        console.log('bridge调用===>')
        return res;
    },
    destory:function(){
        var payload = {"func": "destory"};
        var res = prompt(JSON.stringify(payload));
        return res;
    },
    openfile:function(filepath,datahash,action){
        var payload = {"func": "openfile", "filepath": filepath, "datahash": datahash, "action": action};
        var res = prompt(JSON.stringify(payload));
        return res;
    },
    downloadfile:function(filepath,datahash){
        var payload = {"func": "downloadfile", "filepath": JSON.parse(filepath) , "datahash": datahash};
        var res = prompt(JSON.stringify(payload));
        return res;
    },
    startupload:function(dirpath){
        var payload = {"func": "startupload", "dirpath": dirpath};
        var res = prompt(JSON.stringify(payload));
        return res;
    },
    clearclientcache:function(){
        var payload = {"func": "clearclientcache"};
        var res = prompt(JSON.stringify(payload));
        return res;
    }
}
module.exports = $kmobilebridge;
